import { Link } from 'react-router';

interface FeatureCardProps {
  title: string;
  description: string;
  action: string;
  path: string;
  disabled?: boolean;
}

export function FeatureCard({
  title,
  description,
  action,
  path,
  disabled = false,
}: FeatureCardProps) {
  return (
    <article className="feature-card">
      <div>
        <h3>{title}</h3>
        <p>{description}</p>
      </div>

      {disabled ? (
        <button
          className="card-button"
          type="button"
          disabled
        >
          Coming soon
        </button>
      ) : (
        <Link className="card-button card-link" to={path}>
          {action}
        </Link>
      )}
    </article>
  );
}